import { create } from 'zustand';
import { playNotificationSound } from '@avanta/shared/utils/chat';

interface NotificationsStore {
  soundEnabled: boolean;
  toggleSound: () => void;
  playNotificationSound: () => void;
}

export const useNotificationsStore = create<NotificationsStore>()(set => ({
  soundEnabled: true,
  toggleSound: (): void => set(state => ({ soundEnabled: !state.soundEnabled })),
  playNotificationSound: (): void => {
    const { soundEnabled } = useNotificationsStore.getState();
    if (!soundEnabled) return;
    playNotificationSound();
  },
}));
